import { render } from "./DepositRequestRejected.vue?vue&type=template&id=b505ea3c&scoped=true"
import script from "./DepositRequestRejected.vue?vue&type=script&lang=js"
export * from "./DepositRequestRejected.vue?vue&type=script&lang=js"

import "./DepositRequestRejected.vue?vue&type=style&index=0&id=b505ea3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b505ea3c"]])

export default __exports__